import { render, staticRenderFns } from "./Meetings.vue?vue&type=template&id=04f084bb&scoped=true"
import script from "./Meetings.vue?vue&type=script&lang=js"
export * from "./Meetings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f084bb",
  null
  
)

export default component.exports